<main>
    <div class="card" id="card-config">
        <div class="head">
            <h1>AGViews Connect</h1>
            <div class="linha row">
                <div class="col-4">
                    <label class="w-100"> AGViews Connect do Cliente:
                        <select class="form-control" type="number" [(ngModel)]="clienteId"
                            (ngModelChange)="listarAgviewsConnectPaginate()">
                            <option value="">Sem cliente vinculado</option>
                            <option [value]="cliente.sr_id" *ngFor="let cliente of clientes">
                                {{cliente.vc_nome}}
                            </option>
                        </select>
                    </label>
                </div>
                <div class="col-2">
                    <label class="w-100">Produto:
                        <select class="form-control" type="number" [(ngModel)]="produtoId"
                            (ngModelChange)="listarAgviewsConnectPaginate()">
                            <option value="">
                                Selecionar todos
                            </option>
                            <option [value]="produto.sr_id" *ngFor="let produto of produtos">
                                {{produto.vc_nome}}
                            </option>
                        </select>
                    </label>
                </div>
                <div class="col-4">
                    <label class="w-100">Pesquisar:
                        <input id="searchbar" matInput (keyup)="pesquisarAgviewsConnect($event)" name="search"
                            class="form-control" type="search" placeholder="">
                    </label>
                </div>

                <span>lista de todos os AGViews Connect</span>
            </div>
        </div>
        <div *ngIf="!carregandoAgviewsConnect" class="table-responsive overflow">
            <table mat-table [dataSource]="dataSource" class="table">
                <ng-container matColumnDef="sr_id">
                    <th mat-header-cell *matHeaderCellDef class="sr_id" mat-sort-header>ID</th>
                    <td mat-cell *matCellDef="let agviewConnect" class="sr_id">
                        {{agviewConnect.sr_id}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="vc_imei">
                    <th mat-header-cell *matHeaderCellDef class="vc_imei" mat-sort-header>IMEI</th>
                    <td mat-cell *matCellDef="let agviewConnect" class="vc_imei">
                        {{agviewConnect.vc_imei}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="vc_produto">
                    <th mat-header-cell *matHeaderCellDef class="vc_produto" mat-sort-header>Produto</th>
                    <td mat-cell *matCellDef="let agviewConnect" class="vc_produto">
                        {{agviewConnect.vc_produto}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="ts_criado_em">
                    <th mat-header-cell *matHeaderCellDef class="ts_criado_em" mat-sort-header>Data de
                        ativação</th>
                    <td mat-cell *matCellDef="let agviewConnect" class="ts_criado_em">
                        {{agviewConnect.ts_criado_em | date: "dd/MM/yyyy"}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="controls">
                    <th mat-header-cell *matHeaderCellDef class="controls" mat-sort-header></th>
                    <td mat-cell *matCellDef="let agviewConnect" class="controls">
                        <button *ngIf="verificarPermissao(['editar_agviews_connect'])" class="btn-nav"
                            routerLink="../agviewsConnect/atualizar/{{agviewConnect.sr_id}}">
                            <mat-icon class="material-icons-sharp">
                                edit
                            </mat-icon>Editar
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
            </table>
            <div class="lista-vazia" *ngIf="semAgviewsConnect">
                <p id="mensagem">Lista de AGViews Connect está vazia</p>
            </div>
        </div>
    </div>
    <div class="load" *ngIf="carregandoAgviewsConnect">
        <mat-progress-spinner diameter=30 class="example-margin" [color]="color" [mode]="mode" [value]="value">
        </mat-progress-spinner>
    </div>
    <mat-paginator fxLayoutAlign="center center" [pageSize]="100">
    </mat-paginator>
</main>